import { css } from 'emotion';
import { helvetica, aqua, lightGrey, grey, museo900 } from 'inside-out/global-styles';

export const wrapperStyle = css({
	...helvetica,
	fontSize: 0,
	letterSpacing: 0,
	wordSpacing: 0,
});

export const inputStyle = width =>
	css({
		backgroundColor: '#F6F6F6',
		display: 'inline-block',
		outline: '#000',
		border: `1px solid ${lightGrey}`,
		borderRight: 'none',
		borderRadius: '6px 0 0 6px',
		height: '46px',
		width: width,
		padding: '12.5px',
		boxSizing: 'border-box',
		color: '#8A8B8C',
		fontSize: '16px',
		verticalAlign: 'top',

		'&::placeholder': {
			color: '#8A8B8C',
			fontSize: '16px',
		},
	});

export const labelStyle = css({
	fontSize: '14px',
	color: grey,
	lineHeight: '29px',
	marginBottom: '10px',
	wordSpacing: 'initial',
	letterSpacing: 'initial',
	display: 'block',
});

export const submitStyle = isText =>
	css({
		...museo900,
		letterSpacing: '0.58px',
		backgroundColor: aqua,
		border: 'none',
		borderRadius: '0 6px 6px 0',
		padding: isText ? '0 8px' : 0,
		textTransform: 'uppercase',
		fontSize: '14px',
		lineHeight: '16px',
		boxSizing: 'border-box',
		paddingTop: '2px',
		color: '#fff',
		height: '46px',
		width: isText ? 'auto' : '46px',
		display: 'inline-block',
		verticalAlign: 'top',
	});



// WEBPACK FOOTER //
// ./src/components/shared/singleFieldForm/styles.js